/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';
import isUndefined from 'lodash/isUndefined';
import { GuestCounterRow, FlexRow, FlexCol } from 'sarsaparilla';
import { AttendeeGroupsProps } from '../props';
import { MAX_GROUP_COUNT } from '../constants';

export default class AttendeeInfoForm extends PureComponent {
    static defaultProps = {
        groups: {},
    };

    static propTypes = {
        groups: AttendeeGroupsProps,
        attendeeInfo: PropTypes.objectOf(PropTypes.number),
        onChange: PropTypes.func,
    };

    componentDidMount() {
        this.props.onChange(this.props.attendeeInfo, true);
    }

    getCounts = () => {
        const { groups, attendeeInfo = {} } = this.props;
        const counts = {};
        for (const key of Object.keys(groups)) {
            const min = this.getMin(key);
            counts[key] = attendeeInfo[key] || min;
        }
        return counts;
    };

    handleChangeCount = (key, val) => {
        const min = this.getMin(key);
        const counts = this.getCounts();
        counts[key] = val >= min ? val : min;
        this.props.onChange(counts, true);
    };

    getMin = (key) => {
        const { groups } = this.props;
        const group = groups[key] || {};
        if (group && !isUndefined(group.attendee_min)) {
            return group.attendee_min;
        }
        if (group && !isUndefined(group.min_count)) {
            return group.min_count;
        }
        return group && group.is_required ? 1 : 0;
    };

    render() {
        const { groups } = this.props;

        if (!groups) {
            return null;
        }

        const counts = this.getCounts();

        return (
            <FlexRow className="attendee-info-form">
                {Object.values(groups).map((group) => {
                    const name = group.name || group.key;
                    const label = `Number of ${capitalize(name)}`;
                    const minVal = this.getMin(name);

                    return (
                        <FlexCol lg={6} key={name}>
                            <div className="rec-form-item-wrap">
                                <div className="rec-guest-counter-wrap">
                                    <GuestCounterRow
                                        id={group.key}
                                        key={name}
                                        guestType={{
                                            key: name,
                                            type: name,
                                            label,
                                            ...group,
                                        }}
                                        isRequired={group.is_required}
                                        isDecreaseDisabled={
                                            group.is_required && counts[name] <= minVal
                                        }
                                        count={counts[name]}
                                        min={minVal}
                                        maxTotalGuestsReached={
                                            group.attendee_max >= MAX_GROUP_COUNT ||
                                            group.max_count >= MAX_GROUP_COUNT ||
                                            counts[name] >= MAX_GROUP_COUNT
                                        }
                                        changeCount={this.handleChangeCount}
                                    />
                                </div>
                            </div>
                        </FlexCol>
                    );
                })}
            </FlexRow>
        );
    }
}
